import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/app/components/swapComponent.tsx");
